/**
 * CreateWorkOrderWrapper
 *
 * Purpose:
 * - Wraps WO create page to operate within unified vendor orders context.
 * - Preserves returnTab in URL and overrides navigation to return to vendor orders.
 */
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CONTRACTORS, WORK_ORDER, VENDOR, VENDOR_ORDERS } from "../../constants/route-paths";
import CreateWorkOrder from '../projects/project-execution/create-work-order';
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function CreateWorkOrderWrapper(props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.WORK_ORDERS;
  const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB);

  // Custom navigate function that intercepts WO list navigation
  const customNavigate = (path) => {
    if (path === `/${CONTRACTORS}/${WORK_ORDER}`) {
      // Always redirect to vendor orders with the correct tab and sub-tab for create operations
      let url = `/${VENDOR}/${VENDOR_ORDERS}?${VENDOR_URL_PARAM.TAB}=${returnTab}`;
      if (returnSubTab) {
        url += `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`;
      }
      navigate(url);
    } else {
      navigate(path);
    }
  };
  
  return (
    <CreateWorkOrder
      {...props}
      customNavigate={customNavigate}
    />
  );
}

export default CreateWorkOrderWrapper;
